import { useCallback, useState } from 'react'

import { useAuthenticatedRequestor } from '@app/rest/rest.hooks'

import { ValidatePinStatusId } from './interfaces'
import { verifyPIN } from './rest'

import type { IUseValidatePin } from './interfaces';

export function useValidatePin(): IUseValidatePin {
  const requestor = useAuthenticatedRequestor()
  const [validated, setValidated] = useState<ValidatePinStatusId>(
    ValidatePinStatusId.Default,
  )

  const validatePin = useCallback(
    async (pin: string) => {
      if (pin.length === 0) {
        setValidated(ValidatePinStatusId.Default)
        return false
      }

      try {
        const response = await requestor(verifyPIN(pin))

        if (response.status !== 200) {
          throw new Error(
            `server returned a non 200 response '${response.status}'`,
          )
        }

        const isValid = response.data?.status === true
        setValidated(
          isValid ? ValidatePinStatusId.Success : ValidatePinStatusId.Error,
        )
        return isValid
      } catch {
        setValidated(ValidatePinStatusId.Error)
        return false
      }
    },
    [requestor],
  )

  return [validated, validatePin]
}
